import { Fancybox } from "@fancyapps/ui";

function pdfSlider() {
  $('.pdf-slider__pages').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    variableWidth: true,
    // slidesToShow: 6,
    responsive: [{// breakpoint: 767,
      // settings: {
      //     slidesToShow: 3,
      // }
    }]
  });
}

$(document).ready(function () {
  pdfSlider();
});